import { render } from "./ProspectSiteRank.vue?vue&type=template&id=47fedf97"
import script from "./ProspectSiteRank.vue?vue&type=script&lang=js"
export * from "./ProspectSiteRank.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__